import { post } from "@/api/common/request";

// POST /auth/login
// 入参：{ username, password }
export const login = (data) =>
  post("/auth/login", data, {
    // 登录接口不带已有 token
    meta: { isToken: false },
  });

